import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { DropDownListValue } from '../../entity/conditionvalue/dropdownlistvalue';
import { EnumStringValue } from '../../entity/controltype/dropdownlist/stringenumvalue';

export class DropDownHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const ddv = (qc.value as DropDownListValue);
        if(ddv === undefined || ddv === null || Object.keys(ddv).length === 0 || Object.keys(ddv.value || {}).length === 0)
            return [];
        return [{
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.Equal, //equal
            // 'Value' : (ddv.value.getEnumValue() as EnumStringValue),
            'Value' : ddv.value,
            'Relation' : RelationType.And, //and
            'Expresstype': ValueType.Value
        }];
    }
}